export default __webpack_public_path__ + "static/media/airtable.28ba5dd7.png";